import { Button } from "components/buttons/button/Button";
import { useNavigate } from "react-router";

export const CreateExternalLinkButton = () => {
  const navigate = useNavigate();
  return (
    <Button className="create-button" primary onClick={() => navigate("create")}>
      Create Link
    </Button>
  );
};
